import useAccessControl from 'legacy/components/AccessControl/useAccessControl'
import { Flipper } from 'legacy/contexts/flipper/FlipperContext'

// Delete this and go with the `true` case once `dashboard_store_ops_nav` flipper is fully enabled.
export const useStoreOpsNav = () => {
  const hasAccess = useAccessControl()
  const useStoreOperationsNav = hasAccess({ warehouseFlippers: Flipper.StoreOperationNavigation })
  return useStoreOperationsNav
}
